 <div class="pageContent">
  <div class="pageTitle">
    <h2>Historial Procesos</h2>
  </div>
  <button type="button" (click)="openReportModal()" class="ms-Button">Descargar Reporte General</button>
  <app-data-table tableId="datatableHistorial" [serverSide]="true" [serverData]="getDataTableHistorial" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
  <div class="pageTitle">
    <h2 id="processId"></h2>
  </div>
  <table datatable [dtOptions]="dtOptionsDetalleEjecucionProceso" [dtTrigger]="dtTrigger" class="ms-Table ms-Table--selectable order-column row-border" style="width: 100%" id="datatableDetalleEjecucionProcesos"></table>

  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader cancel-observation">
      <div id="dialogCreateEdit" class="ms-Dialog-title">Motivo cancelación proceso</div>
      <form [formGroup]="cancelProcessForm" (ngSubmit)="enviarAccionProceso()" name="cancelProcessForm">
        <div class="ms-Dialog-content">
          <app-text-area [frm]="cancelProcessForm" formControlName="Observacion" [readonly]="viewObs" [required]="false" label="Observaciones" rows="3"></app-text-area>
        </div>
        <div *ngIf="viewObs" style="margin-top: 24px;">
          <app-button buttonClass="ms-Button ms-Dialog-action" buttonId="btnClose" (buttonClick)="closeCancelModal()" label="Aceptar"></app-button>
        </div>
        <div *ngIf="!viewObs">
          <app-form-buttons 
          [botonProcesando]="botonProcesando"
          buttonCancelId="btnCancel"
          labelCancel="Cancelar"
          buttonSaveId="btnCreateEdit"
          labelSave="Guardar"
          labelLoading="Cargando" 
          [frm]="cancelProcessForm"
          (cancel)="clearCancelForm()">
          </app-form-buttons>
        </div>
      </form>
    </div>
  </div>

  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader download-report">
      <div id="dialogCreateEdit" class="ms-Dialog-title">Descargar Reporte General</div>
      <form [formGroup]="reportForm" (ngSubmit)="descargarReporteGeneral()" name="reportForm">
        <div class="ms-Dialog-content">
          <app-date-range-box [frm]="reportForm" formControlNameInit="fechaInicio" formControlNameEnd="fechaFin" [required]="true" label="Rango de fechas reporte"></app-date-range-box>
        </div>
        <div>
          <app-form-buttons 
          [botonProcesando]="botonProcesando"
          buttonCancelId="btnCancel"
          labelCancel="Cancelar"
          buttonSaveId="btnCreateEdit"
          labelSave="Descargar"
          labelLoading="Cargando" 
          [frm]="reportForm"
          (cancel)="clearReportForm()">
          </app-form-buttons>
        </div>
      </form>
    </div>
  </div>

</div>

<app-modal-notify #crearModal></app-modal-notify> 
